import React, { useState } from 'react';

const faqData = [
  {
    id: 1,
    question: 'WiCanvasの設置に必要なものは何ですか?',
    answer: '電源コンセントとWi-Fi環境があれば設置可能です。特別な配線工事は不要で、届いたその日から使用開始できます。',
  },
  {
    id: 2,
    question: '複数台を同時に管理できますか?',
    answer: 'はい、専用の管理システムを使用して、複数台のWiCanvasを一括管理できます。コンテンツの配信スケジュールも個別に設定可能です。',
  },
  {
    id: 3,
    question: 'どのようなコンテンツを表示できますか?',
    answer: '動画(MP4)、静止画(JPEG、PNG等)など、幅広いフォーマットに対応しています。',
  },
  {
    id: 4,
    question: '保証期間はどのくらいですか?',
    answer: '製品には1年間の標準保証が付いています。延長保証についてはお気軽にご相談ください。',
  },
  {
    id: 5,
    question: '導入前にデモを見ることは可能ですか?',
    answer: 'はい、実機デモンストレーションや、お客様の施設での無料トライアルも実施しています。お気軽にお問い合わせください。',
  },
];

export const FAQ: React.FC = () => {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggleFaq = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="faq">
      <div className="container">
        <h2 className="section-title">よくあるご質問</h2>
        <div className="faq-list">
          {faqData.map((faq) => (
            <div key={faq.id} className="faq-item">
              <button
                className="faq-question"
                onClick={() => toggleFaq(faq.id)}
              >
                <span>{faq.question}</span>
                <span className="faq-icon">{openId === faq.id ? '−' : '+'}</span>
              </button>
              {openId === faq.id && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
